exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  background-image: url('/assets/icon-search.png');\n  background-repeat: no-repeat;\n  background-position: 97% 50%;\n  padding:4px;\n  border: thin solid silver;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/filter-input/filter-input.component.css
// module id = ../../../../../src/app/filter-input/filter-input.component.css
// module chunks = main